import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

function SEO({ title, description, urlPath, imageUrl, extraMeta = [], extraLink = [] }) {
  const baseUrl = 'https://synapsestudios.com'
  const titleTemplate = `%s | Synapse Studios`

  const link = []

  const meta = [
    {
      name: `viewport`,
      content: `width=device-width, initial-scale=1`,
    },
    {
      property: `og:title`,
      content: title,
    },
    {
      name: `description`,
      property: `og:description`,
      content: description,
    },
    {
      property: `og:image`,
      content: `${imageUrl}`,
    },
    {
      property: `og:url`,
      content: `${baseUrl}${urlPath}`,
    },
    {
      property: `og:site_name`,
      content: `Synapse Studios`,
    },
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:site`,
      content: `@synapsestudios`,
    },
  ]

  // Check if an "og:type" property was passed in meta, add one for website if not
  if (extraMeta.filter(i => i.property === `og:type`).length < 1) {
    meta.push({
      property: `og:type`,
      content: `website`,
    })
  }

  return (
    <Helmet
      title={title}
      titleTemplate={titleTemplate}
      meta={meta.concat(extraMeta)}
      link={link.concat(extraLink)}
    />
  )
}

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  urlPath: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  meta: PropTypes.arrayOf(PropTypes.object),
}

export default SEO
